import React from "react";
import { Icon } from "rhombus-react";

import './EmptyDash.css';

/**
 * EmptyDash Cells
 */
export function EmptyDash(props){
	let val = props.value;

	if(!val || val === null || val.length === 0){
		return <Icon name="fa-horizontal-rule" iconStyle="far" className="center-icon empty-dash" />;
	}

	return props.value;
}

EmptyDash.defaultProps = {
	value:"",
};


const EmptyDashCell = {
	width:120,
	sortable:true,
	resizable:true,
	formatter:EmptyDash,
};

export default EmptyDashCell;
